export default __webpack_public_path__ + "static/media/bartholomew.2581cc35.txt";